<div>
    <app-module-form></app-module-form>
</div>
<div>
    <app-module-list></app-module-list>
</div>